export enum RepresentationType {
  FREELANCE = 'Non-Represented',
  AGENCY_REPRESENTATION = 'Agency Representation',
  BLANK = '',
}
